import { API_URL } from "./constants";

export class PaywallError extends Error {
	constructor() {
		super("Subscription required");
		this.name = "PaywallError";
	}
}

export async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
	const method = (options?.method ?? "GET").toUpperCase();
	const headers: Record<string, string> = {
		...(method !== "GET" && { "Content-Type": "application/json" }),
		...(options?.headers as Record<string, string>),
	};
	const res = await fetch(`${API_URL}${path}`, {
		...options,
		credentials: "include",
		headers,
	});
	if (!res.ok) {
		const body = (await res.json().catch(() => null)) as {
			error?: string;
			paywall?: boolean;
		} | null;
		if (res.status === 403 && body?.paywall) {
			throw new PaywallError();
		}
		const message = body?.error ?? `API error: ${res.status}`;
		throw new Error(message);
	}
	return res.json() as Promise<T>;
}
